import type { FaireProductEntity } from "../../entity_types/product";

export const p_ezyqfw5yt2: FaireProductEntity = {
  token: "p_ezyqfw5yt2",
  type: "product",
  name: "Miaoberry Organic Baby Monthly Milestone Blanket|Eucalyptus",
  brandToken: "b_6jbtamncqg",
  brandName: "Miaoberry",
  imageUrl:
    "https://cdn.faire.com/fastly/dcdf25d49b5821b5e39fd1785f0f83a8b817100b2e8ae7329f14c2cbfd18a783.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/299a9fbfad535a93c01ed4bbf63e4d9f74d6eba68e5f5892b1cf13eaa504970e.jpeg",
    "https://cdn.faire.com/fastly/8cf208e4cdc10ae12a81dc833a365b381babb42fe8f5163f9bde186218dface8.jpeg",
    "https://cdn.faire.com/fastly/bbf8efed0945db438d9fd419112f5a0457ce946cb2f0b19c23ee2366e18812f2.jpeg",
    "https://cdn.faire.com/fastly/6a2d5695ca3f132bb08a28d69f001503c3d284b520298cb23fe81e838939b98b.jpeg",
    "https://cdn.faire.com/fastly/6c04dbac46061ea9c1aa0041255aa44665b31a192163a452f7b033a5685fa94d.jpeg",
    "https://cdn.faire.com/fastly/673789c8212765c1c8c2159aaaa857a3e03d49aa4e190894f4d727417b6776d3.jpeg",
    "https://cdn.faire.com/fastly/02d47da0cb0ea091dacb256faeb67daa52499a5c91fe3e66c22a12e7c84906a5.jpeg",
    "https://cdn.faire.com/fastly/7777a9cb167b2d885e98812c55fd7d8fb0f95303988f5f77ddd01bf1a9462434.jpeg",
  ],
  priceDollars: 14.98,
  description:
    "\nColor: Dark (Sage) Green\n\nFeatures: \n\n * 💚 BUT FIRST, SAFE|ORGANIC-- Protect Your Baby and Our Mother Earth. Say No to All Harmful Chemicals and Processes. Designed to Sooth Even the Most Sensitive Skin, Miaoberry 100% GOTS Certified Organic Cotton Muslin Photo Blanket Is the Softest, Toxic-Free, Safe Blanket for Your Precious Baby. The Open Weave of Muslin Makes It Thermal Regulating and Naturally Stretchy. It’s also Hypoallergenic and Gentle. \n * 💚 HELLO SUMMER ALL- NATURAL GREEN WREATH –Every Miaoberry Picture Blanket Is Uniquely Designed, Hand Illustrated and Printed With Baby-Safe, Eco-Friendly Ink. This Boho Eucalyptus Wreath Age Blanket Goes Perfect With Trendy Boho Nursery Décor, and Many Fashionable Colors and Outfits.",
  tags: [],
  msrpDollars: 29.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:31.083Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
